export default () => ({
  component: 'coupons-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
